import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { backend } from "../../services/backend";

const RecoverPasswordForm = () => {
  const [isPending, Pending] = useState(false);
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();

  const formPassHandler = () => {
    if (isPending) return;
      if (!email) return;
      Pending(true);
      backend.requestRecoverPassword(email).then((res) => {
        if (res.error) {
          toast("Ошибка отправки письма. Обратитесь в техподдержку");
          return;
        }
        if (res.message) {
          toast("Ссылка на восстановление отправлена на Ваш email");
          setTimeout(() => {
            document.location.href="/"
          }, 3000)
        }
      }).catch((e) => {
        toast("Ошибка отправки письма. Обратитесь в техподдержку");
      }).finally(() => {
        Pending(false)
      })
  };

  return (
    <div className="loginform">
      <div className="loginFormHeading">
        <h3 className="heading3">Восстановление пароля</h3>
      </div>
      <div className="loginFormInner">
         <div className="fieldName">Введите email:</div>
            <div className="field">
              <input
                type="text"
                value={email}
                onChange={(event: any) => setEmail(event.target?.value?.toLowerCase())}
              />
            </div>
      </div>
      <div
        className={`btn loginActionButton${isPending ? " disabled" : ""}`}
        onClick={formPassHandler}
      >
        Восстановить пароль
      </div>
    </div>
  );
};

export default RecoverPasswordForm;
